import { useOutletContext } from "react-router";
import { useMenus } from "../../api/queries";
import { Alert } from "../../components/ui";
import type { ShellContext } from "../AppShell";
import { QrCard } from "./QrCard";
import { QrPrint } from "./QrPrint";

/** Coduri QR (prototype page `qr`): the code and its downloads, then the print preview (A6 tent, 5 × 5 cm sticker). */
export function QrPage() {
  const { membership } = useOutletContext<ShellContext>();
  const r = membership.restaurant;
  const menus = useMenus(r.id);
  const live = (menus.data ?? []).some((m) => m.publicVisible && !m.archived);

  return (
    <>
      <div className="stack" style={{ gap: 6 }}>
        <h1 className="h1">Coduri QR</h1>
        <p className="page-sub" style={{ margin: 0, maxWidth: 680 }}>
          Un singur cod pentru toate meniurile active. Duce mereu la același link, deci nu trebuie retipărit
          când actualizezi meniul.
        </p>
      </div>
      {menus.isSuccess && !live && (
        <Alert tone="warning">
          Niciun meniu nu este publicat încă. Codul funcționează, dar clienții vor vedea „Meniul nu este
          publicat încă” până publici.
        </Alert>
      )}
      <div style={{ maxWidth: 560 }}>
        <QrCard publicUrl={r.publicUrl} slug={r.slug} restaurantName={r.name} />
      </div>
      <div style={{ maxWidth: 560 }}>
        <QrPrint publicUrl={r.publicUrl} restaurantName={r.name} />
      </div>
    </>
  );
}
